import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ppa-public',
  template: '<router-outlet><router-outlet>'
})
export class PublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
